import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './hooks/useAuth';
import { useConfig } from './hooks/useConfig';
import { DashboardLayout } from './layouts/DashboardLayout';
import DashboardPage from './pages/DashboardPage';
import LoginPage from './pages/LoginPage';
import TaxesPage from './pages/TaxesPage';
import UsersPage from './pages/UsersPage';
import AccountsPage from './pages/AccountsPage';
import TransactionsPage from './pages/TransactionsPage';
import DocumentsPage from './pages/DocumentsPage';
import CashFlowPage from './pages/CashFlowPage';
import DREPage from './pages/DREPage';
import ProjectionPage from './pages/ProjectionPage';
import ReportsPage from './pages/ReportsPage';
import ExtratoPage from './pages/ExtratoPage';
import EmployeesPage from './pages/EmployeesPage';
import ImportPage from './pages/ImportPage';
import ConciliacaoPage from './pages/ConciliacaoPage';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center">Carregando...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

function FeatureRoute({ feature, children }: { feature: string; children: React.ReactNode }) {
  const { hasFeature } = useConfig();
  if (!hasFeature(feature)) return <Navigate to="/" replace />;
  return <>{children}</>;
}

function PlaceholderPage({ title }: { title: string }) {
  return (
    <div className="text-center py-12">
      <h2 className="text-xl font-semibold text-gray-700">{title}</h2>
      <p className="text-gray-500 mt-2">Em breve</p>
    </div>
  );
}

function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<DashboardPage />} />
        <Route path="/users" element={<UsersPage />} />
        <Route path="/contas" element={<AccountsPage />} />
        <Route path="/lancamentos" element={<TransactionsPage />} />
        <Route path="/documentos" element={<DocumentsPage />} />
        <Route path="/fluxo-de-caixa" element={<CashFlowPage />} />
        <Route path="/dre" element={<DREPage />} />
        <Route path="/projecao" element={<ProjectionPage />} />
        <Route path="/extrato" element={<ExtratoPage />} />
        <Route path="/contas-pagar" element={<FeatureRoute feature="contas-pagar"><PlaceholderPage title="Contas a Pagar" /></FeatureRoute>} />
        <Route path="/contas-receber" element={<FeatureRoute feature="contas-receber"><PlaceholderPage title="Contas a Receber" /></FeatureRoute>} />
        <Route path="/impostos" element={<FeatureRoute feature="impostos"><TaxesPage /></FeatureRoute>} />
        <Route path="/funcionarios" element={<FeatureRoute feature="funcionarios"><EmployeesPage /></FeatureRoute>} />
        <Route path="/importar" element={<ImportPage />} />
        <Route path="/conciliacao" element={<ConciliacaoPage />} />
        <Route path="/relatorios" element={<ReportsPage />} />
      </Route>
    </Routes>
  );
}

export default App;
